import api from '../config/api';

export const getProjects = searchParams => api.get(`/actions/${searchParams}`);
